import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTextMax = createSVG({
    width: 48,
    children: (jsx("path", { d: "m41.29 18.002-3.687-6.174 3.481-5.83H38.41l-2.144 3.601-2.143-3.601h-2.676l3.482 5.848-3.67 6.156h2.675l2.332-3.91 2.333 3.91zm-12.879 0h2.573L26.765 5.998h-2.933l-4.201 12.004h2.555l.72-2.16h4.785zm-4.75-4.373 1.646-4.905 1.647 4.905zm-5.204-7.631h-2.435l-3.43 5.676-3.447-5.676H6.71v12.004h2.366v-7.768l3.379 5.556h.274l3.379-5.574v7.786h2.35z" })),
});

export { IconTextMax };
